import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CprResolver } from './resolver/cpr.resolver';
import { CprTableScreenComponent } from './screens/table/cpr-table-screen.component';

const loadDetail = () =>
  import('./screens/cpr-detail.screen.component').then((m) => m.CprEditScreen);

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'CPRs' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: CprTableScreenComponent,
      },
      {
        path: 'create',
        pathMatch: 'full',
        data: { breadcrumb: 'Create' },
        loadComponent: loadDetail,
      },
      {
        path: ':id',
        data: { breadcrumbDynamic: 'cpr' },
        resolve: { data: CprResolver },
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: loadDetail,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CprRoutingModule {}
